(function () {
  const form = document.getElementById(
    'views-exposed-form-careers-listings-page-1'
  );
  const submitBtn = document.getElementById('edit-submit-careers-listings');
  var baseUrl = '';
  if (submitBtn) {
    submitBtn.addEventListener('click', (event) => {
      event.preventDefault();

      const formData = new FormData(form);
      const searchParams = new URLSearchParams();

      for (let [key, value] of formData.entries()) {
        if (value == '') {
          key = 'all';
        } else {
          key = '';
        }
        searchParams.append(key, value);
      }
      if (window.location.href.includes('careers/jobs')) {
        let start = path.indexOf('careers/jobs');
        baseUrl = window.location.href.substring(0, start);
      } else {
        let start = path.indexOf('careers');
        baseUrl = window.location.href.substring(0, start);
      }
      const searchParamsurl =
        baseUrl +
        '/careers/jobs/' +
        searchParams
          .toString()
          .replace(/=&/g, '/')
          .replace(/=/g, '')
          .replace(/&/g, '/');
      const submitUrl = decodeURIComponent(searchParamsurl)
        .replace(/\+/g, ' ')
        .replace(/undefined/g, 'all');
      window.location.href = submitUrl;
    });
  }

  const url = decodeURIComponent(window.location.href).replace(/\+/g, ' ');
  // Extract the path from the URL and remove the leading slash
  const path = url.slice(1);

  // Find the index of the "careers/jobs" segment in the path
  const start = path.indexOf('careers/jobs');

  // If "careers/jobs" is found in the path
  if (start !== -1) {
    // Extract the substring of the path after "careers/jobs" and split it into segments
    const segments = path.slice(start + 'careers/jobs/'.length).split('/');
    // Get the last three segments from the array
    var lastThreeSegments = segments.slice(-4);
    if (lastThreeSegments.length > 1) {
      let jobSearch = document.getElementById('edit-st');
      if (jobSearch && lastThreeSegments[0] !== 'all') {
        jobSearch.value = lastThreeSegments[0];
      }
      let jobLocation = document.getElementById('edit-joblocation');

      if (jobLocation && lastThreeSegments[1] !== 'all') {
        jobLocation.value = lastThreeSegments[1];
      }
      let jobFamily = document.getElementById('edit-jobfamily');
      if (jobFamily && lastThreeSegments[2] !== 'all') {
        jobFamily.value = lastThreeSegments[2];
      }
      let locCountry = document.getElementById('edit-loccountry');
      if (locCountry && lastThreeSegments[3] !== 'all') {
        locCountry.value = lastThreeSegments[3];
      }
    }
  }
})();
